import { ComponentDataSourceService } from '../../component-data-source.service';
import { Observable } from 'rxjs';
import { DataSourceFunction } from '../../component-data-source.service';
import { LoadDataParams } from '../../../../interfaces/DataSource/DataSourceParams.interface';
import { environment } from '../../../../environment/environment';

export const event_participation = (service: ComponentDataSourceService): DataSourceFunction => ({
  name: 'event_participation',
  description: 'Get event participation status and waiting list',
  execute: (params?: LoadDataParams): Observable<any> => {
    if (params?.filters) {
      const eventFilter = params.filters.find(f => f.column === 'eventId');
      if (eventFilter) {
        return service.http.get(`${environment.apiUrl}/events/${eventFilter.value}/participation`);
      }
    }
    throw new Error('eventId filter is required');
  },
  settings: {
    methods: {
      register: (eventId: number, userId: number) => 
        service.http.post(`${environment.apiUrl}/events/${eventId}/register`, { userId }),
      unregister: (eventId: number, userId: number) => 
        service.http.delete(`${environment.apiUrl}/events/${eventId}/register/${userId}`),
      markAttendance: (eventId: number, userId: number, attended: boolean) => 
        service.http.post(`${environment.apiUrl}/events/${eventId}/attendance`, { userId, attended })
    }
  }
}); 